export default __webpack_public_path__ + "static/media/card_l_red.1ddf6144.png";